// 折线图option
export function linePicOption(data = { dataList: {}, monthList: [] }) {
  return {
    title: {
      text: "交易额/万元",
    },
    tooltip: {
      trigger: "axis",
      // formatter:'{a}：{c}万元'
      formatter: function (arg) {
        var temp = "";
        var total = 0;
        for (var item of arg) {
          total = total + item.data;
          temp += `${item.marker} ${item.seriesName}：${
            item.data ? item.data.toFixed(4) : 0
          }万元 </br>`;
        }
        return `${arg[0].name}<br/>${temp}`;
      },
    },
    color: ["#1890FF", "#A0C664", "#FACC14", "#73C9E6"],
    legend: {
      data: ["工程建设", "政府采购", "国有产权", "国土交易"],
      icon: "pin",
      right: "4%",
    },
    grid: {
      left: "3%",
      right: "4%",
      bottom: "3%",
      containLabel: true,
    },
    xAxis: {
      type: "category",
      boundaryGap: true,
      data: data.monthList,
      axisLabel: {
        rotate: 45,
      },
    },
    yAxis: {
      type: "value",
      axisLine: {
        show: false,
      },
      axisTick: {
        show: false,
      },
      splitLine: {
        lineStyle: {
          type: "dashed", //设置网格线类型 dotted：虚线   solid:实线
        },
      },
    },
    series: [
      {
        name: "工程建设",
        type: "line",
        data: data.dataList.GC,
        smooth: true,
      },
      {
        name: "政府采购",
        type: "line",
        data: data.dataList.CG,
        smooth: true,
      },
      {
        name: "国有产权",
        type: "line",
        data: data.dataList.CQ,
        smooth: true,
      },
      {
        name: "国土交易",
        type: "line",
        data: data.dataList.GT,
        smooth: true,
      },
    ],
  };
}
// 柱状图option
export function barPicOption(data) {
  return {
    title: {
      text: "交易量",
    },
    tooltip: {
      trigger: "axis",
      // formatter:'{a}：{c}宗'
      formatter: function (arg) {
        var temp = "";
        var total = 0;
        for (var item of arg) {
          total = total + item.data;
          temp += `${item.marker} ${item.seriesName}：${item.data}宗 <br/>`;
        }
        return `${arg[0].name}<br/>${temp}`;
      },
    },
    color: ["#1890FF", "#A0C664", "#FACC14", "#73C9E6"],
    legend: {
      data: ["工程建设", "政府采购", "国有产权", "国土交易"],
      icon: "pin",
      right: "4%",
    },
    grid: {
      left: "3%",
      right: "4%",
      bottom: "3%",
      containLabel: true,
    },
    xAxis: {
      type: "category",
      boundaryGap: true,
      data: data.monthList,
      axisLabel: {
        rotate: 45,
      },
    },
    yAxis: {
      type: "value",
      axisLine: {
        show: false,
      },
      axisTick: {
        show: false,
      },
      splitLine: {
        lineStyle: {
          type: "dashed", //设置网格线类型 dotted：虚线   solid:实线
        },
      },
    },
    series: [
      {
        name: "工程建设",
        type: "bar",
        stack: "交易量",
        barWidth: 25,
        data: data.dataList.GC,
        emphasis: {
          focus: "series",
        },
      },
      {
        name: "政府采购",
        type: "bar",
        stack: "交易量",
        barWidth: 25,
        data: data.dataList.CG,
        emphasis: {
          focus: "series",
        },
      },
      {
        name: "国有产权",
        type: "bar",
        stack: "交易量",
        barWidth: 25,
        data: data.dataList.CQ,
        emphasis: {
          focus: "series",
        },
      },
      {
        name: "国土交易",
        type: "bar",
        stack: "交易量",
        barWidth: 25,
        data: data.dataList.GT,
        emphasis: {
          focus: "series",
        },
      },
    ],
  };
}

// 领导角色项目待办任务nav列表
export const leaderTaskNav = [
  { value: 1, text: "按角色统计" },
  { value: 2, text: "按项目类型统计" },
];
// 工程建设业务节点
export const gcjsFilterList = [
  { text: "招标项目登记", value: "招标项目登记" },
  { text: "招标委托合同", value: "招标委托合同" },
  { text: "招标项目计划", value: "招标项目计划" },
  { text: "招标文件", value: "招标文件" },
  { text: "开评标场地预约", value: "开评标场地预约" },
  { text: "招标文件澄清与修改", value: "招标文件澄清与修改" },
  { text: "招标公告", value: "招标公告" },
  { text: "邀请书", value: "邀请书" },
  { text: "中标候选人公示", value: "中标候选人公示" },
  { text: "开标情况", value: "开标情况" },
  { text: "评标情况", value: "评标情况" },
  { text: "确认中标人", value: "确认中标人" },
  { text: "中标结果公告", value: "中标结果公告" },
  { text: "中标通知书", value: "中标通知书" },
  { text: "合同管理", value: "合同管理" },
  { text: "合同履约", value: "合同履约" },
  { text: "招标异常", value: "招标异常" },
  { text: "项目参数变更", value: "项目参数变更" },
  { text: "投标有效期变更", value: "投标有效期变更" },
];
// 政府采购业务节点
export const zfcgFilterList = [
  { text: "采购计划", value: "采购计划" },
  { text: "采购项目信息", value: "采购项目信息" },
  { text: "谈判文件", value: "谈判文件" },
  { text: "磋商文件", value: "磋商文件" },
  { text: "询价单", value: "询价单" },
  { text: "单一来源文件", value: "单一来源文件" },
  { text: "采购文件", value: "采购文件" },
  { text: "资审场地预约", value: "资审场地预约" },
  { text: "采购公告", value: "采购公告" },
  { text: "竞争性磋商", value: "竞争性磋商" },
  { text: "单一来源公示", value: "单一来源公示" },
  { text: "邀请书", value: "邀请书" },
  { text: "资格预审公告", value: "资格预审公告" },
  { text: "询价通知书", value: "询价通知书" },
  { text: "征询意见公示", value: "征询意见公示" },
  { text: "专家论证", value: "专家论证" },
  { text: "资审澄清修改", value: "资审澄清修改" },
  { text: "开启资格预审文件", value: "开启资格预审文件" },
  { text: "资审结果通知书", value: "资审结果通知书" },
  { text: "资审文件", value: "资审文件" },
  { text: "开标记录表", value: "开标记录表" },
  { text: "评标记录表", value: "评标记录表" },
  { text: "中标结果公告", value: "中标结果公告" },
  { text: "成交通知书", value: "成交通知书" },
  { text: "合同", value: "合同" },
  { text: "更正公告", value: "更正公告" },
  { text: "项目参数变更", value: "项目参数变更" },
  { text: "投标有效期变更", value: "投标有效期变更" },
];
// 国土交易业务节点
export const gtjyFilterList = [
  { text: "招标项目", value: "招标项目" },
  { text: "自由竞价", value: "自由竞价" },
  { text: "限时竞价", value: "限时竞价" },
  { text: "成交结果公告", value: "成交结果公告" },
  { text: "成交通知书", value: "成交通知书" },
  { text: "招标异常", value: "招标异常" },
];
// 国有产权业务节点
export const gycqFilterList = [
  { text: "招标项目", value: "招标项目" },
  { text: "自由竞价", value: "自由竞价" },
  { text: "限时竞价", value: "限时竞价" },
  { text: "成交结果公告", value: "成交结果公告" },
  { text: "成交通知书", value: "成交通知书" },
  { text: "招标异常", value: "招标异常" },
];
// 审核角色便捷入口列表
export const quickList = [
  { value: "", text: "常用" },
  { value: 1, text: "交易系统" },
  { value: 2, text: "监管系统" },
  { value: 3, text: "服务系统" },
  { value: 4, text: "其它" },
];

// 审核角色待办事项nav点击 刷新和搜索判断对应
export function checkNav(data) {
  let arr = ["GC", "CG", "GT", "CQ"];
  let temp = {};
  if (arr.includes(data)) {
    temp.type = true;
    temp.opt = {
      pageIndex: 1,
      pageSize: 5,
      total: 0,
      pageSizes: [5, 10, 15],
    };
    return temp;
  } else if (["QT"].includes(data)) {
    temp.type = "QT";
    temp.opt = {
      pageIndex: 1,
      pageSize: 5,
      total: 0,
      pageSizes: [5, 10, 15],
    };
    return temp;
  } else {
    temp.type = false;
    temp.opt = {
      pageIndex: 1,
      pageSize: 4,
      total: 0,
      pageSizes: [4, 8, 12],
    };
    return temp;
  }
}
// 项目类型列表
export const projectTypeList = [
  { value: "GC", text: "工程建设" },
  { value: "CG", text: "政府采购" },
  { value: "GT", text: "国有产权" },
  { value: "CQ", text: "国土交易" },
];
// 预警类型列表
export const warnTypeList = [
  { value: "", text: "全部" },
  { value: 1, text: "红色" },
  { value: 2, text: "黄色" },
];
